/** Modular settlement details. These frames describe static decorative art;
 * map-owned platforms and interactions retain all gameplay authority.
 */
export const SETTLEMENT_DETAIL_TEMPLATES = {
  timber_fence_panel: { kind: 'dock', name: 'Timber rail fence', frame: { w: 144, h: 88 }, band: 'architecture' },
  timber_fence_gate: { kind: 'dock', name: 'Braced garden gate', frame: { w: 128, h: 104 }, band: 'architecture' },
  stone_wall_segment: { kind: 'moor_stone', name: 'Low dry-stone wall', frame: { w: 144, h: 72 }, band: 'architecture' },
  stone_pier_post: { kind: 'colonnade_column', name: 'Capped masonry pier', frame: { w: 56, h: 100 }, band: 'architecture' },
  rope_rail_segment: { kind: 'dock', name: 'Slack-rope quay rail', frame: { w: 144, h: 80 }, band: 'architecture' },
  harbor_bollard: { kind: 'dock', name: 'Coiled-rope mooring bollard', frame: { w: 60, h: 60 }, band: 'vegetation' },
  open_supply_crate: { kind: 'dock', name: 'Open slatted supply crate', frame: { w: 88, h: 76 }, band: 'vegetation',
    supportSurfaces: [{ x: 10, y: 8, width: 70, height: 8 }] },
  market_goods_table: { kind: 'dock', name: 'Cloth-covered market table', frame: { w: 148, h: 98 }, band: 'vegetation' },
} as const;

export type SettlementDetailTemplate = keyof typeof SETTLEMENT_DETAIL_TEMPLATES;
export type BoundaryPropTemplate = Extract<SettlementDetailTemplate, `timber_${string}` | `stone_${string}`>;
export type QuaysideDetailTemplate = Exclude<SettlementDetailTemplate, BoundaryPropTemplate>;
